import React from 'react';
import ReactDOM from "react-dom";
import ModalOverlayRLookUp from "../Form/ModalOverlayRLookUp";
import Modal, {ModalBody, ModalHeader} from "../Modal";
import Form from "../FormNew/Form";


const ModalOverlay = (props) => {
  return <div
  style={{zIndex:100}}
  >
    <Modal
      isOpen={props.isOpen}
      modalCallback={props.modalCallback}>
      <ModalHeader title={props.title}/>
      <ModalBody>
        {props.children}
      </ModalBody>
    </Modal>
  </div>;
}

function TableModal(props) {
  return <React.Fragment>
    {ReactDOM.createPortal(<ModalOverlay {...props}/>, document.getElementById('table-modal'))}
  </React.Fragment>
}

export default TableModal;